'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import type { ReactNode } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useDocumentEvent } from '@/hooks/useDocumentEvent';
import { useHydrateOnInteraction } from '@/hooks/useHydrateOnInteraction';
import { useWebsiteHoverPreviewFeature } from './hooks/useWebsiteHoverPreviewFeature';
const GlobalLinkEnhancerInner = dynamic(() => import('./GlobalLinkEnhancerInner').then(mod => mod.GlobalLinkEnhancerInner), {
  ssr: false
});
export function GlobalLinkEnhancer(t0) {
  const $ = _c(8);
  const {
    children
  } = t0;
  const {
    user
  } = useAuth();
  const isHoverPreviewEnabled = useWebsiteHoverPreviewFeature(user?.id ?? null);
  let t1;
  if ($[0] !== isHoverPreviewEnabled) {
    t1 = {
      enabled: isHoverPreviewEnabled
    };
    $[0] = isHoverPreviewEnabled;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    hasInteracted,
    markInteracted
  } = useHydrateOnInteraction(t1);
  const shouldListenForHover = isHoverPreviewEnabled && !hasInteracted;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      passive: true
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  useDocumentEvent("mouseover", markInteracted, t2, shouldListenForHover);
  if (!(isHoverPreviewEnabled && hasInteracted)) {
    let t3;
    if ($[3] !== children) {
      t3 = <>{children}</>;
      $[3] = children;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t3;
  if ($[5] !== children || $[6] !== isHoverPreviewEnabled) {
    t3 = <GlobalLinkEnhancerInner isHoverPreviewEnabled={isHoverPreviewEnabled}>{children}</GlobalLinkEnhancerInner>;
    $[5] = children;
    $[6] = isHoverPreviewEnabled;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}